// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__O1p2c","thumb":"Switch_thumb__g01l7"};